import { render, staticRenderFns } from "./ScreenPerseo.vue?vue&type=template&id=5206c1f2"
import script from "./ScreenPerseo.vue?vue&type=script&lang=js"
export * from "./ScreenPerseo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports